import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext';
import Button from '../Button';

const HeroSection = () => {
  const { isDarkMode } = useTheme();

  return (
    <section className={`relative min-h-full md:min-h-screen z-[1] ${isDarkMode ? 'bg-[#000000]' : 'bg-white'}`}>
      <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8  pt-12 pb-10 md:pt-40">
        <div className="flex flex-col-reverse sm:flex-row items-center justify-center gap-8 lg:gap-12">
          {/* Left Content */}
          <motion.div 
            className="flex-1 text-center sm:text-left gap-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className={`text-[28px] sm:text-[32px] md:text-[36px] lg:text-[44px] font-medium tracking-[0%] leading-[1.2] lg:leading-[52px] ${
              isDarkMode ? 'text-white' : 'text-black'
            } font-lexend mb-4 lg:mb-6 max-w-[100%] whitespace-pre-wrap`}>
              {'Crowdsource Innovation for Your Organization'}
            </h1>
            <p className={`text-[16px] sm:text-[18px] lg:text-[20px] font-light tracking-[0%] leading-[1.5] lg:leading-[auto] ${
              isDarkMode ? 'text-[#fff]' : 'text-[#000]'
            } font-lexend max-w-[600px] mx-auto sm:mx-0 mb-6 lg:mb-8`}>
              Leverage your data and collaborate with top AI/ML talent to refine existing solutions or create groundbreaking new models—while retaining full ownership
            </p>
            <Button 
              text="Host Your Quest"
              onClick={() => {}}
              className="gradient"
              link="https://app.lunor.quest/"
            />
          </motion.div>

          {/* Right Image */}
          <motion.div 
            className="flex-1 flex items-center justify-center mb-8 sm:mb-0"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <img 
              src="/assets/OrgHero.png" 
              alt="AI Collaboration"
              width={570}
              height={318}
              className="w-full max-w-[400px] sm:max-w-[450px] md:max-w-[500px] lg:max-w-[570px] h-auto lg:h-[318px] object-contain rounded-[20px]"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 